import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    container: { maxHeight: 200, overflowY: "auto", paddingRight: theme.spacing(3) },
    title: { fontWeight: 600 },
    list: { margin: 0, paddingLeft: theme.spacing(5), overflowWrap: "anywhere" },
    content: { marginBottom: theme.spacing(4) },
    buttonBox: { display: "flex", justifyContent: "space-between", marginTop: theme.spacing(5) },
    buttonSubBox: { display: "flex", gap: theme.spacing(1) },
    toogleIcon: { fontSize: 18, color: theme.palette.emteria.text.secondary },
    splitLayout: {
        display: "flex",
        flexWrap: "wrap",
        flex: 1,
        minWidth: 0,
        width: "100%",
        gap: theme.spacing(3),
        alignItems: "flex-start",
        "@media (max-width: 768px)": { flexDirection: "column" },
    },
    editorContainer: {
        flex: "0 0 auto",
        minWidth: 0,
        "& textarea": { width: "48vw" },
        "@media (max-width: 768px)": {
            flex: "1 1 auto",
            width: "100%",
            "& textarea": { width: "100%" },
        },
    },
    notesContainer: { display: "flex", flexDirection: "column", gap: theme.spacing(2), flex: "1 1 0", minWidth: 300 },
}));
